import { setCountAction, setHeadlineTypeSync } from "./_common.js";
import areaTypeFilter from "./area-type-filter.js";

const main = () => {
    if (document.querySelector('#page-search-area') === null) return;
    setCountAction();
    areaTypeFilter();
    setHeadlineTypeSync();
}

export default main;
